import React, { useState, useEffect, useRef } from "react"

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Label,
  CardImg,
  Table
} from "reactstrap"
import { Delete,Edit } from '@mui/icons-material';
import CustomModal from "../Common/CustomModal"
import {
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import { AvForm, AvField } from "availity-reactstrap-validation"

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"

import Axios from "../../helpers/axios_helper";
import * as SHelper from "../../helpers/session_helper"
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify/dist/react-toastify';
import mediaImage from "../../assets/images/media.jpeg";
const moment = require('moment');

const Model = (props) => {
  const [instructors, setInstructors] = useState([]);
  const [selectedInstructors, setSelectedInstructors] = useState([]);
  const [courseInstructors, setCourseInstructors] = useState([]);

  const selectedItem = useRef(0)
  const [update_status_modal_center, setUpdate_status_modal_center] = useState(false);

  const handleSubmit = async (event, errors, values) => {
    
    var updateData=[];
    updateData.push({
      courseId:props.courseId,
      moduleId:props.moduleId,
      instructorProfileId:selectedInstructors.value
    })

    const jsonData = {
      courseInstructors:updateData
    }

    await Axios.post("/courseInstructor/bulk", jsonData)
      .then(async (response) => {
        if (response.data.status === 200) {
          toast.success('Coordination team updated successfully!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
          });
          setSelectedInstructors(null);
          setTimeout(() => {
            fetchData();
          }, 1000);
              
        } else {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
          });
        }
      })
      .catch((e) => {
        toast.error(e, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
      })
  }

  const deleteCourseInstructor = async () =>{
    setUpdate_status_modal_center(false);
    await Axios.delete(`/courseInstructor/id/${selectedItem.current}`)
        .then((response) => {
            if (response.data.status == 200) {
              toast.success('Coordination team updated successfully!', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000,
              });
              fetchData();
            }
      });
  }

  const fetchData = async () =>{
      setCourseInstructors([])
      await Axios.get(`/courseInstructor/list/${props.courseId}&${props.moduleId}`)
        .then((response) => {
            if (response.data.status == 200) {
              setCourseInstructors(response.data.data);
              // let filteredInstructors =[]
              // response.data.data.forEach(element => {
              //   filteredInstructors.push({label:element.instructorFullName,value:element.id})
              // });
              // setSelectedInstructors(filteredInstructors)
            }
      });
  }

  useEffect(async ()=>{
    if(props.courseId && props.moduleId){
        fetchData();
        if(SHelper.userHasEditPermission()){
          await Axios.get(`/instructorProfile/dropdown`)
          .then((response) => {
              if (response.data.status == 200) {
                setInstructors(response.data.data);
              }
              else {
                setInstructors([])
              }
          });
        }
    }
  },[props.courseId,props.moduleId])

  return (
    <Row>
        <Col xl="12">
          <Card>
            <CardTitle style={{ fontSize: "18px", textAlign: "center", opacity:"0.7" }}>Coordination Team</CardTitle>
            <CardBody style={{ paddingTop: "0.5rem" }}>
              <AvForm className="needs-validation" onSubmit={handleSubmit}>
              {SHelper.userHasEditPermission() && <>
                <Col md="12">
                  <Row>
                    <Col md="12">
                      <div className="mb-3">
                        <Label>Name</Label>
                        <Select
                          value={selectedInstructors}
                          isMulti={false}
                          onChange={(data) => {
                            setSelectedInstructors(data);
                          }}
                          options={instructors}
                          classNamePrefix="select2-selection"
                        />
                      </div>
                    </Col>
                    
                  </Row>
                </Col>
                <div className="actions clearfix">
                    <Button
                        style={{ float: "right", marginLeft: "10px" }}
                        type="button"
                        color="primary"
                        onClick={handleSubmit}
                    >Update</Button>
                </div>
                </>}
                <CardTitle typeof="h4" >Instructors List</CardTitle>
                  <Col md={12}>
                      <div className="table-responsive">
                          <Table className="table mb-0">
                              <thead>
                                  <tr>
                                      <th>#</th>
                                      <th>Name</th>
                                      <th>Contact</th>
                                      <th>Email</th>
                                      {SHelper.userHasEditPermission() &&
                                      <th>Action</th>}
                                  </tr>
                              </thead>
                              <tbody>
                              {courseInstructors.map((item,i)=>{
                                    return (
                                        <tr key={i}>
                                            <th scope="row">{i+1}</th>
                                            <td>{item.instructorProfile.instructorFullName}</td>
                                            <td>{item.instructorProfile.instructorContactNo}</td>
                                            <td>{item.instructorProfile.instructorEmail}</td>
                                            {SHelper.userHasEditPermission() && 
                                            <td>
                                                <Box sx="flex">
                                                    <Tooltip arrow placement="left" title="Delete">
                                                    <IconButton style={{color:"red"}} onClick={() => {selectedItem.current=item.id; setUpdate_status_modal_center(true);}}>
                                                        <Delete />
                                                    </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </td>}
                                        </tr>
                                      )
                                  })}
                              </tbody>
                          </Table>
                      </div>
                  </Col>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
        <CustomModal modelShow={update_status_modal_center} handleCallback={deleteCourseInstructor} bodyMsg={"Do you want to delete this data ?"}/>
    </Row>
  )
}

export default Model
